import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  tech_generated_lead_count: number;
}

const TechGeneratedLeadsCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "TGLs",
  accessorFn: (row) => row.tech_generated_lead_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default TechGeneratedLeadsCol;
